import { Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject, Subscription } from 'rxjs';
import { Belpex } from '../../../models/belpex.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { fadeInOut } from '../../../services/animations';
import { BelpexService } from '../../../services/belpex.service';

@Component({
    selector: 'belpex-overview',
    template: require('./belpex-overview.component.html'),
    styles: [require('./belpex-overview.component.css')],
    animations: [fadeInOut]
})
export class BelpexOverviewComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];
    loading: boolean;

    pagingData: Belpex[] = [];
    currentPage = 1;
    pageSize = 20;
    search = '';
    totalRecords = 0;
    orderByField = 'Date';
    isDesc = false;
    modelChanged = new Subject<string>();
    constructor(private accountService: AccountService, private belpexService: BelpexService, private ngxLogger: NGXLogger) { }

    ngOnInit() {
        const modelSub = this.modelChanged.debounceTime(500)
            .subscribe(() => {
                this.initializeDataListByPage(1);
            });
        this.subscribers.push(modelSub);
        this.initializeDataListByPage(1);
    }

    // private getData() {
    //     this.loading = true;
    //     const getSubscriber = this.belpexService.get().subscribe((res: Belpex[]) => {
    //         this.belpex = res;
    //         // this.belpex.forEach(z => {
    //         //     z.CreatedDate = new Date(z.CreatedDate).toISOString().substring(0, 10);
    //         // });
    //         this.loading = false;
    //     }, error => {
    //         this.ngxLogger.error(error.message);
    //         throw error;
    //     });
    //     this.subscribers.push(getSubscriber);
    // }

    initializeDataListByPage(page: number) {
        this.loading = true;
        this.currentPage = page;
        const dataListByPageSub = this.belpexService.getDataListByPage(page, this.pageSize, this.orderByField, this.isDesc, this.search)
            .subscribe((data: any) => {
                if (data && data.Item1) {
                    this.pagingData = data.Item1;
                    this.totalRecords = data.Item2;
                } else {
                    this.pagingData = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.error(err);
                this.ngxLogger.error(err.message);
            });
        this.subscribers.push(dataListByPageSub);
    }

    globalSearch() {
        this.modelChanged.next();
    }

    paginate(event: any) {
        this.pageSize = event.rows;
        this.initializeDataListByPage(event.page + 1);
    }

    customSort(event: any) {
        let isDesc: boolean;
        if (event.order === -1) {
            isDesc = true;
        } else {
            isDesc = false;
        }
        if (event.field !== this.orderByField || isDesc !== this.isDesc) {
            this.orderByField = event.field;
            this.isDesc = isDesc;
            this.initializeDataListByPage(this.currentPage);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canbelpexOverviewPermission() {
        return this.accountService.userHasPermission(Permission.belpexOverviewPermission);
    }

    get canbelpexExportPermission() {
        return this.accountService.userHasPermission(Permission.belpexExportPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/belpex/belpex-overview/belpex-overview.component.ts